import { Address, PaymentMethod } from "@core/types";
import { getFullAddressForAddressType } from "./utils";
import i18n from "../i18n";

const escapeHtml = (text: string) =>
  text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

interface MakeOrderConfirmationMessageProps {
  address: Address | null;
  paymentMethodTitle: PaymentMethod["title"];
  deliveryDate: Date | null;
  deliveryInterval: string;
  isExpressMode: boolean;
  isTaxiMasterTurned: boolean;
}

export const makeOrderConfirmationMessage = ({
  address,
  paymentMethodTitle,
  deliveryDate,
  deliveryInterval,
  isExpressMode,
  isTaxiMasterTurned,
}: MakeOrderConfirmationMessageProps) => {
  const fullAddress = address?.fullAddress || getFullAddressForAddressType(address ?? {});

  const intervalText = isExpressMode || isTaxiMasterTurned ? i18n.t("Express") + " ⚡" : deliveryInterval;

  const deliveryDateAndInterval =
    deliveryDate && intervalText ? `${deliveryDate.toLocaleDateString()} | ${intervalText}` : "";

  return `
    <div>
      <div>${i18n.t("Delivery address")}: <br /> <strong>${escapeHtml(fullAddress || "-")}</strong></div>
      <br />
      <div>${i18n.t("Payment Method")}:  <br /> <strong>${escapeHtml(paymentMethodTitle || "-")}</strong></div>
      <br />
      <div>${i18n.t("Delivery date and interval")}:  <br /> <strong>${escapeHtml(deliveryDateAndInterval)}</strong></div>
      <br />
      <div>${i18n.t("orderConfirmationMessage")}</div>
    </div>
  `;
};
